import styled from "styled-components";

export const UploaderTitleContainer = styled.div`
  display: flex;
  align-items: center;
`;

export const UploaderTitleDescription = styled.div`
  display: flex;
  align-items: center;
  pointer-events: none;
  cursor: default;
  color: ${({ theme: { palette } }) => palette.iconDisabled};
`;
